const initState = {
    activeHash: '',
    activeTab: 0,
};

export const TABS_CHANGED = 'TABS_CHANGED';

export const setTabsState = (data) => ({ type: TABS_CHANGED, payload: data });

export default (state = initState, action) => {
    switch (action.type) {
        case TABS_CHANGED:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};
